import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import Service from "@/services/KepatuhanVisiteDpjpService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "kepatuhan-visite-dpjp"
})
class KepatuhanVisiteDpjpModule extends VuexModule {
  // --- State ---
  sessions: any[] = [];
  currentSession: any = null;
  reasonDefinitions: any[] = [];
  loading = false;
  pagination = {
    currentPage: 1,
    lastPage: 1,
    perPage: 20,
    total: 0
  };

  // Dashboard
  dashboard: any = null;
  scorecards: any[] = [];
  monthlyReport: any = null;

  // --- Mutations ---

  @Mutation SET_SESSIONS(val: any[]) {
    this.sessions = val;
  }

  @Mutation SET_CURRENT_SESSION(val: any) {
    this.currentSession = val;
  }

  @Mutation SET_REASON_DEFINITIONS(val: any[]) {
    this.reasonDefinitions = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_PAGINATION(val: any) {
    this.pagination = val;
  }

  @Mutation SET_DASHBOARD(val: any) {
    this.dashboard = val;
  }

  @Mutation SET_SCORECARDS(val: any[]) {
    this.scorecards = val;
  }

  @Mutation SET_MONTHLY_REPORT(val: any) {
    this.monthlyReport = val;
  }

  // --- Actions ---

  @Action
  async loadReasonDefinitions() {
    try {
      const dt = await Service.getReasonDefinitions();
      this.SET_REASON_DEFINITIONS(dt.data.data || []);
    } catch (e) {
      console.error("loadReasonDefinitions error:", e);
    }
  }

  @Action
  async loadSessions(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await Service.getSessions(params);
      const resp = dt.data;
      this.SET_SESSIONS(resp.data?.data || resp.data || []);
      if (resp.meta) {
        this.SET_PAGINATION({
          currentPage: resp.meta.current_page,
          lastPage: resp.meta.last_page,
          perPage: resp.meta.per_page,
          total: resp.meta.total
        });
      }
    } catch (e) {
      console.error("loadSessions error:", e);
    }
    this.SET_LOADING(false);
  }

  @Action
  async loadSession(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await Service.getSession(id);
      this.SET_CURRENT_SESSION(dt.data.data || null);
    } catch (e) {
      console.error("loadSession error:", e);
    }
    this.SET_LOADING(false);
  }

  @Action
  async loadDashboard(params?: { bulan?: number; tahun?: number }) {
    this.SET_LOADING(true);
    try {
      const dt = await Service.getDashboard(params?.bulan, params?.tahun);
      this.SET_DASHBOARD(dt.data.data || null);
    } catch (e) {
      console.error("loadDashboard error:", e);
    }
    this.SET_LOADING(false);
  }

  @Action
  async loadScorecards(params: { bulan: number; tahun: number }) {
    try {
      const dt = await Service.getScorecards(params.bulan, params.tahun);
      this.SET_SCORECARDS(dt.data.data || []);
    } catch (e) {
      console.error("loadScorecards error:", e);
    }
  }

  @Action
  async loadMonthlyReport(params: { bulan: number; tahun: number }) {
    try {
      const dt = await Service.getMonthlyReport(params.bulan, params.tahun);
      this.SET_MONTHLY_REPORT(dt.data.data || null);
    } catch (e) {
      console.error("loadMonthlyReport error:", e);
    }
  }
}

export const storeKepatuhanVisiteDpjp = getModule(KepatuhanVisiteDpjpModule);
